// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBlock_container__2x8I3","lockup":"ContentBlock_lockup__XvHha"};